var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKunci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#703893",
    d: "M16.213 8.571a3.956 3.956 0 0 0-3.814 3H3.857v1.715h8.538c.415 1.688 1.971 3 3.814 3a3.9 3.9 0 0 0 3.934-3.858c0-2.125-1.766-3.857-3.93-3.857m.073 6a2.143 2.143 0 1 1 0-4.286a2.143 2.143 0 0 1 0 4.286m-6.111-5.94c0 .635-.476 1.149-1.076 1.136c-.587 0-1.067-.514-1.054-1.157v-.04H7.02v.022c0 .634-.475 1.153-1.071 1.14c-.592 0-1.072-.515-1.059-1.162H3.857v2.572h7.273l.013-2.572h-.968zm6.968 3.797c0 .476-.57.858-1.286.858V11.57c.703 0 1.286.382 1.286.857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKunci);
export default __webpack_public_path__ + "static/media/kunci.5a6790b0ea13840baa3f4945122ee395.svg";
export { ForwardRef as ReactComponent };